export default __webpack_public_path__ + "static/media/arrow-img-calculator.1d3a73fc.svg";